<script lang="ts" setup>
import type { LinkSection } from '@convatec/180medical-website/types/app'

interface Props {
  interestLinks?: LinkSection
}

const { interestLinks } = defineProps<Props>()
</script>

<template>
  <div class="bg-med-light-aqua">
    <div class="container-fluid">
      <ul class="post-footer__row">
        <li>
          <strong>{{ interestLinks?.title }}</strong> {{ interestLinks?.description }}
        </li>

        <li
          v-for="(link, index) in interestLinks?.links"
          :key="index"
        >
          <ULink
            :to="useCmsUrl(link.url)"
            :locale="false"
            class="font-bold"
          >
            {{ link.text }}
          </ULink>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
.post-footer__row {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  line-height: 1.78;

  a {
    font-weight: 700;
    color: var(--color-med-deep-navy);
  }

  li {
    position: relative;
    padding: 26px 0px;

    &::after {
      content: '';
      position: absolute;
      width: 100vw;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      border-top: solid 1px var(--color-med-aqua);
    }

    &:last-child {
      &::after {
        display: none;
      }
    }
  }

  @media (min-width: 768px) {
    padding-top: 30px;
    padding-bottom: 30px;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px 0px;

    li {
      position: relative;
      padding: 0px 40px 0px 0px;
      flex: 0 1 auto;

      &::after {
        width: auto;
        height: 100%;
        top: 0px;
        left: auto;
        bottom: 0px;
        right: 20px;
        transform: translateX(0);
        border: none;
        border-right: solid 2px var(--color-med-aqua);
      }

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }
  }
}
</style>
